// *******************************************************************************
// Map Module
// *******************************************************************************

const mapModules = document.querySelectorAll('.map-module__init');

mapModules.forEach((module) => {
  const allCountries = module.querySelectorAll('.map-module__country');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) allCountries.forEach((el) => el.classList.remove('is-closed'));
      });
    },
    {
      threshold: window.innerHeight <= 1000 ? 0.6 : 0.8,
    },
  );

  observer.observe(module);
});
